import type IAttendanceRecord from '@src/models/interfaces/attendanceRecord.interface';
import AttendanceRecordRepository from '@src/repositories/AttendanceRecordRepository';

interface GetAttendanceRecordParams {
  organizationId: string;
  attendanceRecordId: string;
}

interface ListByEmployeeInScheduledPeriodParams {
  organizationId: string;
  employeeId: string;
  startMillis: number;
  endMillis: number;
}

class AttendanceRecordService {
  private repository: AttendanceRecordRepository;

  constructor(repository: AttendanceRecordRepository = new AttendanceRecordRepository()) {
    this.repository = repository;
  }

  async getAttendanceRecord({
    organizationId,
    attendanceRecordId,
  }: GetAttendanceRecordParams): Promise<IAttendanceRecord | null> {
    return (await this.repository.getAttendanceRecord({
      organizationId,
      attendanceRecordId,
    })) as IAttendanceRecord | null;
  }

  /**
   * Attendance records scheduled for an employee within a time window, mirroring the
   * mobile app query: organizations/{orgId}/attendance_records
   *   where employeeId == employeeId
   *   where scheduledStartAt >= window.start
   *   where scheduledStartAt <= window.end
   */
  async listByEmployeeInScheduledPeriod({
    organizationId,
    employeeId,
    startMillis,
    endMillis,
  }: ListByEmployeeInScheduledPeriodParams): Promise<IAttendanceRecord[]> {
    return (await this.repository.listByEmployeeInScheduledPeriod({
      organizationId,
      employeeId,
      startMillis,
      endMillis,
    })) as IAttendanceRecord[];
  }
}

export default AttendanceRecordService;
